import React, { SVGProps } from 'react'
const SvgSplit = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox='0 0 16 16'
    aria-hidden="true"
    fill='none'
    {...props}
  >
    <path d="M10.6667 2H14M14 2V5.33333M14 2L10 6M5.33333 2H2M2 2V5.33333M2 2L7.21867 7.21867C7.46983 7.46971 7.66832 7.76839 7.80249 8.09718C7.93666 8.42597 8.00381 8.77824 8 9.13333V14.6667"
      stroke="#4489F9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgSplit
